import { TaxFormStatus } from "@wingspanhq/payments/dist/interfaces/taxForm";

export const selectorIsTaxFormProcessing = (taxForm: {
  status: TaxFormStatus;
}): boolean => {
  return taxForm.status === TaxFormStatus.Pending;
};
